<div class="container">
    <table mat-table [dataSource]="conditions()" class="mat-elevation-z8">
        <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

        <!-- Colonne 'isMainCondition' -->
        <ng-container matColumnDef="isMainCondition">
            <th mat-header-cell *matHeaderCellDef class="icon-column"></th>

            <td mat-cell *matCellDef="let element" class="icon-column">
                @if (element.isMainCondition === true) {
                    <mat-icon matTooltip="Condition principale" matTooltipPosition="below">flag</mat-icon>
                }
            </td>
        </ng-container>

        <!-- Colonne 'Id' -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="column-id">Id</th>
            <td mat-cell *matCellDef="let element" class="column-id">{{ element.id }}</td>
        </ng-container>

        <!-- Colonne 'Nom' -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="column-name">Nom</th>
            <td mat-cell *matCellDef="let element" class="column-name" [matTooltip]="element.name" matTooltipPosition="below">{{ element.name }}</td>
        </ng-container>

        <!-- Colonne 'Actions' -->
        <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef aria-label="column actions" class="action-column">
                <button mat-icon-button [disabled]="disabled" (click)="onCreateCondition()" aria-label="Ajouter une condition" class="accent-button">
                    <mat-icon>add</mat-icon>
                </button>
            </th>
            <td mat-cell *matCellDef="let element" class="action-column">
                <button mat-icon-button [disabled]="disabled" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{ element: element }" aria-label="Menu contextuel">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" class="element-row" (dblclick)="onMouseDoubleClick(row, $event)"></tr>
    </table>

    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-element="element">
            <button mat-menu-item [disabled]="disabled" (click)="onEditCondition(element)">
                <mat-icon>edit</mat-icon>
                <span>Editer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDuplicateCondition(element)">
                <mat-icon>edit</mat-icon>
                <span>Dupliquer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onDeleteCondition(element)">
                <mat-icon>delete</mat-icon>
                <span>Supprimer</span>
            </button>
            <button mat-menu-item [disabled]="disabled" (click)="onMarkConditionAsMain(element)">
                <mat-icon>flag</mat-icon>
                <span>Désigner comme condition principale</span>
            </button>
        </ng-template>
    </mat-menu>
</div>
